import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { GalleryDetailService } from './services/gallery-detail.service';
import { GalleryDetail } from './model/gallery-detail.model';


@Component({
  selector: 'app-gallery-detail',
  standalone: true,
  imports: [TranslateModule, NgFor, NgIf],
  templateUrl: './gallery-detail.component.html',
  styleUrl: './gallery-detail.component.css'
})
export class GalleryDetailComponent {

  selectedImage: string | null = null;
  currentLanguage: string = '';
  galleryId!: number;
  galleryDetail!: GalleryDetail;

  baseApiUrl = environment.baseApiUrl;

  constructor(private translate: TranslateService, private route: ActivatedRoute, private galleryDetailService: GalleryDetailService) {}

  ngOnInit() {
    this.currentLanguage = this.translate.currentLang || this.translate.defaultLang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
    })
    
    this.galleryId = +this.route.snapshot.paramMap.get('id')!;
    this.loadGalleryDetail();

  }


 loadGalleryDetail(): void {
  this.galleryDetailService.getGalleryById(this.galleryId).subscribe(
    (response) => {
      this.galleryDetail = response.data;
    },
    (error) => {
      console.error('Error fetching gallery details', error);
    }
  )
 }

  openImage(url: string) {
    this.selectedImage = this.baseApiUrl + '/' + url;
  }

  closeImage() {
    this.selectedImage = null;
  }
}
